import store from '@app/core/store/store';
import React, { useEffect } from 'react';

const OneTrustConsent: React.FC = () => {
  // Used for E2E Testings for bypassing the cookie banner.
  const byPassCookie = localStorage.getItem('bypass-cookie');
  const cookieConsentOneTrustID = store.getState().uiValues.cookieConsentOneTrustID;
  useEffect(() => {
    if (!cookieConsentOneTrustID || byPassCookie) {
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.setAttribute('data-domain-script', cookieConsentOneTrustID);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [cookieConsentOneTrustID, byPassCookie]);

  return <></>;
};

export default OneTrustConsent;
